import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildGetBookingsDataTableFilter,
  useGetBookingsDataTable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'

import type { AssigneeFilterAccess } from './index'

const assigneeFilter = (
  source: ReturnType<typeof useGetBookingsDataTable>,
  accesses: AssigneeFilterAccess[],
  currentAccessId?: string
) => {
  const NameWithAvatar = ({ name }: { name: string }) => {
    return (
      <Box gap="s8" flexDirection="row" alignItems="center">
        <Avatar label={name} size="s32" />
        <Text.Normal size="300">{name}</Text.Normal>
      </Box>
    )
  }

  const options = accesses.map((access) => {
    const name = getFullDisplayName({
      firstName: access.firstName,
      lastName: access.lastName,
    })
    return {
      value: access.id,
      label: name,
      component: <NameWithAvatar name={name} />,
    }
  })

  return buildGetBookingsDataTableFilter(source, {
    title: i18n.t('space_control.my-bookings.datatable.filters.assignee'),
    path: 'accessId',
    identifier: 'accessIdFilter',
    type: FilterType.Id,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
        value: currentAccessId ? [currentAccessId] : undefined,
      },
    ],
    onUpdateValue: (value) => {
      track(trackingEvents.spaceControl.bookings.filterBookings, {
        filter_used: 'accessId',
        value,
      })
    },
  })
}

export default assigneeFilter
